// extracted by mini-css-extract-plugin
export default {"modal":"components-hotel-and-market-currency-profile-currencies-modal-module__modal"};